import HomeComponent from "../../components/home-component/HomeComponent";

const Home = () => {
  return (
    <div>
      <HomeComponent />{" "}
    </div>
  );
};

export default Home;
